import React from 'react';
import { Link, useLocation } from 'react-router';
import clsx from 'clsx';

import { MENU_LIST } from '../../utils/constants';

import styles from './Breadcrumb.module.css';

export const Breadcrumb = ({
  paddingCalc,
}: {
  paddingCalc: { paddingTop: number };
}) => {
  const location = useLocation();
  const paths = location.pathname.split('/').filter(Boolean);

  const crumbs = paths.map((path, index) => ({
    pathName: (MENU_LIST[path] || location.state?.navName)?.toLowerCase(),
    to: `/${paths.slice(0, index + 1).join('/')}`,
  }));

  if (!paths.length) return null;

  return (
    <nav
      aria-label="breadcrumb"
      className={styles.container}
      style={paddingCalc}
    >
      <ul className={styles.breadcrumbList}>
        <li key="home" className={styles.breadcrumbItem}>
          <Link className={styles.breadcrumbItemHover} to="/">
            Главная
          </Link>
        </li>
        {crumbs.map(({ pathName, to }, idx) => (
          <li key={to} className={styles.breadcrumbItem}>
            <span className={styles.slash}>/</span>
            <Link
              to={to}
              className={clsx(
                idx === crumbs.length - 1
                  ? styles.breadcrumbItemActive
                  : styles.breadcrumbItemHover,
              )}
            >
              {pathName}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};
